/*
 * Created by alex@hackerbay.com on 3.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate, Trans} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Col, Container, Row} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import Subtitle from "../../components/Subtitle";
import InfoBox from "../../components/InfoBox";
import FullWidthSaveToCalendarButton from "../../components/FullWidthSaveToCalendarButton";
import StatusBar from "../../components/StatusBar";
import moment from "moment";
import {
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT,
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP,
    statusBoxTimeUntilAppointmentTextHelper
} from "../../common";
import BottomBarActive from "../../components/BottomBarActive";
import RouterShipmentTrackingBox, {DELIVERY_STATUS} from "../../components/RouterShipmentTrackingBox";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView, isMobile} from "react-device-detect";
import SideBarTechnicianInfo from "../../components/SideBarTechnicianInfo";
import SingleButton from "../../components/SingleButton";
import {StatusBarDesktop} from "../../components/StatusBarDesktop";
import timeSlotFormatter from "../../timeSlotFormatter";
import BottomBarPassive from "../../components/BottomBarPassive";
import {getDaysUntilAppointment} from "../../checkCareStageHelper";
import {hardwareWasShipped} from "../../hardwareHelper";
import iconTechnicianCrossedRed from "../../media/icons/technician-crossed-red.png"
import iconTechnicianCrossedWhite from "../../media/icons/technician-crossed-white.png"
import technicianAppointmentRequired from "../../technicianRequired";
import vodafoneLogo from "../../media/icons/vf-logo.png";


class Stage7WaitingForAppointment extends React.Component {
    constructor(props) {
        super(props);

        const appointmentDate = props.ds360APIResult.proposalDate;
        const appointmentMoment = moment(appointmentDate);
        const daysUntilAppointment = getDaysUntilAppointment(appointmentDate);

        this.state = {
            daysUntilTechnicianAppointment: daysUntilAppointment, //Remaining days count
            technicianAppointmentDateText: appointmentMoment.format(MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT)
        };

        if(!isMobile){
            this.state.technicianAppointmentDateText = appointmentMoment.format(MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP)
        }
    }

    hardwareWasShipped = () => {
        return hardwareWasShipped(this.props.orderStatus);
    };

    _technicianAppointmentRequired = () => {
        return technicianAppointmentRequired(this.props.ds360APIResult);
    };

    /**
     * Compile Text Resources
     * @returns {*}
     */
    getTextResources = () => {
        const getBodyTextResource = () => {

            if (this.props.orderStatus && this.props.orderStatus.available === true && this.props.orderStatus.tracking.status !== DELIVERY_STATUS.DELIVERED){
                return "router_was_shipped_body";
            } else {
                return "router_delivery_description_mobile";
            }
        };

        // #267 MyTechie Hinweis ergänzen beim Router-Info-Text
        const getBodyTextResourceMyTechie = () => {

            if (this.props.orderStatus && this.props.orderStatus.available === true && this.props.orderStatus.tracking.status !== DELIVERY_STATUS.DELIVERED){
                return "router_was_shipped_body_mytechie";
            } else {
                return "router_delivery_description_mobile_mytechie";
            }
        };

        if(this._technicianAppointmentRequired() === false){
            return {
                header: "no_technician_required_title",
                body: "no_technician_required_body"
            }
        }

        // adjustedDaysUntilAppointment, updated with #266 CARE-976 WEB: Bugs - Countdown-Anzeige
        const adjustedDaysUntilAppointment = this.state.daysUntilTechnicianAppointment;
        // console.log( "adjustedDaysUntilAppointment: " + adjustedDaysUntilAppointment );
        if (adjustedDaysUntilAppointment >= 15) {
            return {
                header: "countdown_more_than_2_weeks_to_go",
                body: getBodyTextResource()
            };
        }
        if (adjustedDaysUntilAppointment >= 8) {
            return {
                header: "countdown_2_weeks_to_go",
                body: getBodyTextResource()
            }
        }
        if (adjustedDaysUntilAppointment >= 5) {
            return {
                header: "countdown_soon",
                body: getBodyTextResource()
            };
        }
        if (adjustedDaysUntilAppointment == 4) {
            return {
                header: "countdown_are_you_ready",
                body: getBodyTextResource()
            };
        }
        if (adjustedDaysUntilAppointment == 3) {
            return {
                header: "countdown_3_days",
                body: getBodyTextResource()
            };
        }
        if (adjustedDaysUntilAppointment == 2) {
            return {
                header: "countdown_2_days",
                body: getBodyTextResource()
            };
        }
        // Tag vor der Anschaltung: MyTechie Hinweis anzeigen (#267)
        if (adjustedDaysUntilAppointment == 1) {
            return {
                header: "countdown_1_days",
                body: getBodyTextResourceMyTechie()
            };
        }
        // Tag der Anschaltung
        if (adjustedDaysUntilAppointment == 0) {
            return {
                header: "countdown_today",
                body: getBodyTextResource()
            };
        }
        // Anschalttag vorbei
        if (adjustedDaysUntilAppointment < 0) {
            return {
                header: "countdown_passed",
                body: getBodyTextResource()
            };
        }

        return {
            header: "sleep_x_times",
            count: adjustedDaysUntilAppointment,
            body: getBodyTextResource()
        };

    };


    /**
     * getPackageTrackingElement (GLS Tracking Image/Button)
     * @returns {*}
     */
    getPackageTrackingElement = () => {
        if(this.hardwareWasShipped()){
            return <RouterShipmentTrackingBox
                orderStatus={this.props.orderStatus}
            />
        }
        return "";
    };


    /**
     * #267 get YouTube Embedded MyTechie-Video anzeigen - nur am Tag vor der Anschaltung
     * @returns {*}
     */
    getYouTubeMyTechie = () => {

        // Tag vor der Anschaltung: MyTechie Hinweis anzeigen (#267)
        if (this.state.daysUntilTechnicianAppointment == 1) {

            // #267 MyTechie Hinweis
            const youtubeEmbedSrc = `https://www.youtube.com/embed/9w-5MePiSMw`;

            // mobile
            if(isMobile){
                return <div>
                        <Row>
                        <Col xs={12} className={"margin-bottom-10"}>
                            <div style={{width:"100%", height:"200px"}}>
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={youtubeEmbedSrc}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen={true}
                                />
                            </div>
                        </Col>
                    </Row>
                    <SpacerRow/>
                </div>;

            // desktop
            } else {
                return <div>
                    <Row>
                        <Col xs={12} className={"margin-bottom-10"}>
                            <div style={{width:"100%", height:"200px"}}>
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={youtubeEmbedSrc}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen={true}
                                />
                            </div>
                        </Col>
                    </Row>
                    <SpacerRow/>
                </div>;
            }

        }

        return "";

    };


    /**
     * getDesktopChangeAppointmentButton
     * #265 CARE-1002 WEB: Bugs - Techniker-Termin-Änderung (bis 4 Tage vorher): Do Not Show Button if daysUntilTechnicianAppointment is less than 4 (Disable)
     * @returns {*}
     */
    getDesktopChangeAppointmentButton = () => {
        // console.log(this.props.ds360APIResult.customerStatus, this.props.ds360APIResult.customerStatus === "checked", this._technicianAppointmentRequired());
        if( this.props.ds360APIResult.customerStatus === "checked" && this._technicianAppointmentRequired() ){

            if( this.state.daysUntilTechnicianAppointment >= 4 ) {

                return <SingleButton
                    buttonTextResource={"change"}
                    buttonOnClick={this.props.changeAppointment}
                    buttonStyleIsWhite={true}
                    buttonIsDisabled={this.state.daysUntilTechnicianAppointment < 4}
                />;

            } else {

                let textColor = "white";
                return <Row>
                    <Col xs={12}>
                        <p className={"text-bottom-bar-subtitle-vodafone-desktop"} style={{height:"28px", marginBottom:"0", color:textColor}}>
                            {i18n.t("cannot_be_changed")}
                        </p>
                    </Col>
                </Row>;

            }
        }
        return "";
    };

    /**
     * getInfoBox
     * @returns {*}
     */
    getInfoBox = () => {
        if(this.hardwareWasShipped() === false){

            // Appointment can be changed if appointment is at least 4 days in future
            if( this.state.daysUntilTechnicianAppointment >= 4 ) {
                return <InfoBox
                    urlIdent={this.props.urlIdent}
                    cardType={"warning"}
                    textResource={"appointment_can_be_changed"}
                    buttonTextResource={"save_reminder"}
                    showCalendarLink={false}
                    imgUrl={"/favicon.ico"}
                />;

            // Appointment can NOT be changed is less than 4 days in future
            } else {
                return <InfoBox
                    urlIdent={this.props.urlIdent}
                    cardType={"warning"}
                    textResource={"appointment_can_not_be_changed"}
                    buttonTextResource={"save_reminder"}
                    showCalendarLink={false}
                    imgUrl={"/favicon.ico"}
                />;
            }

        }
        return "";
    };

    /**
     * render method
     * @returns {*}
     */
    render() {

        const timeSlot = this.props.ds360APIResult.appointmentTimeSlot;
        const formattedTimeSlot = timeSlotFormatter(timeSlot);
        const timeSlotText = formattedTimeSlot.text;
        const dateText = moment(this.props.ds360APIResult.proposalDate).format(MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP);
        const textResources = this.getTextResources();
        const headerTextResource = textResources.header;
        const bodyTextResource = textResources.body;
        const packageTrackingElement = this.getPackageTrackingElement();

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        // #267 MyTechie YouTube Embedding
        const youtubeResource = this.getYouTubeMyTechie(this.state.daysUntilTechnicianAppointment);

        let infoBox = "";
        const desktopChangeAppointmentButton = this.getDesktopChangeAppointmentButton();
        if(desktopChangeAppointmentButton !== ""){
            infoBox = this.getInfoBox();
        }

        let packageSpacing = "";
        if((!isMobile) && this.hardwareWasShipped()){
            packageSpacing = <SpacerRow/>
        }


        const headerElement = <Header
            textResource={headerTextResource}
            count={textResources.count}
        />;
        let barTitle = "x_days_to_go";
        let header = headerElement;
        let barText;

        if(this._technicianAppointmentRequired() === true){
            barText = "technician_appointment_x";
        }else{
            if(isMobile){
                barText = "line_available_on";
                header = <Row>
                    <Col xs={9}>
                        {headerElement}
                    </Col>
                    <Col xs={3}><img src={iconTechnicianCrossedRed} alt={"no technician required icon"} className={"img-fluid"} /></Col>
                </Row>
            }else{
                barTitle = "line_availability";
                barText = "no_technician_required_info";
            }
        }

        return <Container>

            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <StatusBar
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={this._technicianAppointmentRequired(this.props.ds360APIResult)}
                    customerWillGetAPackage={this.hardwareWasShipped()}
                />
                <SpacerRow/>
                {header}
                <SpacerRow/>
                {youtubeResource}
                <TextBody
                    textResource={bodyTextResource}
                />

                <div className={"margin-top-10"}>
                    {infoBox}
                    <FullWidthSaveToCalendarButton
                        urlIdent={this.props.urlIdent}
                    />
                    <BottomBarActive
                        mainText={barTitle}
                        subText={barText}
                        count={this.state.daysUntilTechnicianAppointment}

                        date={dateText}
                        timeText={"time_o_clock"}
                        time={timeSlotText}
                        technicianAppointmentRequired={this._technicianAppointmentRequired(this.props.ds360APIResult)}
                        shouldShowChangeAppointmentButton={desktopChangeAppointmentButton !== "" && this.state.daysUntilTechnicianAppointment >= 4}
                        isAppointmentButtonDisabled={this.state.daysUntilTechnicianAppointment < 4}

                        buttonTextResource={"change"}
                        buttonOnClick={this.props.changeAppointment}
                    />

                    {packageTrackingElement}
                </div>
            </MobileView>

            <BrowserView>
                <Row>
                {footerLnk}
                </Row>
                <StatusBarDesktop
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={this._technicianAppointmentRequired(this.props.ds360APIResult)}
                    customerWillGetAPackage={this.hardwareWasShipped()}
                />
                <Row>
                    <Col xs={7}  lg={{ size: 5, offset: 1 }} style={{marginTop:"12px"}}>
                        {header}
                        <SpacerRow/>
                        {youtubeResource}
                        <TextBody
                            textResource={bodyTextResource}
                        />
                        <SpacerRow/>
                        <SpacerRow/>
                        <FullWidthSaveToCalendarButton
                            urlIdent={this.props.urlIdent}
                        />
                        <SpacerRow/>
                    </Col>
                    <Col xs={5}  lg={{ size: 4, offset: 1 }}>
                        {packageTrackingElement}
                        {packageSpacing}
                        <Row className={"round-corners shadow bg-red-gradient"} style={{margin:"0 0 0 0"}}>
                            <Col xs={12}>
                                <SideBarTechnicianInfo
                                    technicianAppointmentRequired={this._technicianAppointmentRequired(this.props.ds360APIResult)}
                                    dateText={dateText}
                                    timeText={"time_o_clock"}
                                    time={timeSlotText}
                                    barStyleIsWhite={true}
                                />
                                <SpacerRow/>
                                {infoBox}
                                <SpacerRow/>
                                {desktopChangeAppointmentButton}
                                <SpacerRow/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage7WaitingForAppointment);
